import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ListQuerySchema } from "@/jenesys-types/data/communication";
import { AppError } from "@/jenesys-types/errors";

interface DocumentQueriesState {
  isLoading: boolean;
  error?: AppError;
  queries: ListQuerySchema[] | null;
  documentId: string | null;
}

const initialState: DocumentQueriesState = {
  isLoading: false,
  error: undefined,
  queries: null,
  documentId: null
};

export interface FetchDocumentQueriesPayload {
  companyId: string;
  documentId: string;
}

const documentQueriesSlice = createSlice({
  name: "documentQueries",
  initialState,
  reducers: {
    fetchDocumentQueries: {
      reducer: (state: DocumentQueriesState, action: PayloadAction<FetchDocumentQueriesPayload>) => {
        state.isLoading = true;
        state.error = undefined;
        state.documentId = action.payload.documentId;
      },
      prepare: (companyId: string, documentId: string) => {
        const payload = { companyId, documentId };
        return { payload };
      }
    },
    fetchDocumentQueriesSuccess: {
      reducer: (state: DocumentQueriesState, action: PayloadAction<ListQuerySchema[]>) => {
        state.isLoading = false;
        state.queries = action.payload;
        state.error = undefined;
      },
      prepare: (queries: ListQuerySchema[]) => ({
        payload: queries
      })
    },
    fetchDocumentQueriesFailure: {
      reducer: (state: DocumentQueriesState, action: PayloadAction<AppError>) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      prepare: (error: AppError) => ({
        payload: error
      })
    },
    clearDocumentQueries: (state: DocumentQueriesState) => {
      state.queries = [];
      state.error = undefined;
    }
  }
});

export const {
  fetchDocumentQueries,
  fetchDocumentQueriesSuccess,
  fetchDocumentQueriesFailure,
  clearDocumentQueries
} = documentQueriesSlice.actions;

export const selectDocumentQueriesState = (state: any) => state.features.transactions.documentQueries;
export const selectDocumentQueries = (state: any) => selectDocumentQueriesState(state).queries;
export const selectDocumentQueriesLoading = (state: any) => selectDocumentQueriesState(state).isLoading;
export const selectDocumentQueriesError = (state: any) => selectDocumentQueriesState(state).error;

export default documentQueriesSlice.reducer;